import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useAppDispatch } from '../../../../hooks/hooks';
import { setDialog, setToast } from '../../../../app/appSlice';
import { useDeleteFunctionMutation } from '../../DataLibrarySlice';


const DeleteDatalibrayItem = ({ itemName, itemID, onDeleteDone }: { itemName: string, itemID: string, onDeleteDone: () => void }) => {
  const [deleteDataLibraryItem, { ...deleteStatus }] = useDeleteFunctionMutation();
  const dispatch = useAppDispatch();

  const dialogContent = () => {
    return (
      <>
        <div className="mb-3">
          Etes-vous sûr de vouloir supprimer la brique{" "}
          <span className="font-bold">{itemName}</span> ?
        </div>
        {footerDialog()}
      </>
    );
  };

  const footerDialog = () => {
    return (
      <div style={{ float: "right" }}>
        <Button
          label={"ANNULER"}
          onClick={() => dispatch(setDialog(undefined))}
          className="mr-3 p-button-outlined p-button-sm"
        />

        <Button
          id="hook-form"
          onClick={async () => {
            try {
              await deleteDataLibraryItem({ id: itemID }).unwrap();
              onDeleteDone();
              dispatch(setDialog(undefined));
            } catch (e) {
              let message = `Echec de la suppression de ${itemName}`;
              //@ts-ignore
              if (e.status === 409) {
                message = `Echec de la suppression de ${itemName} car au moins une version de ce traitement existe`;
              }
              dispatch(
                setToast({
                  title: `Erreur`,
                  content: message,
                  severity: "error",
                  life: 6000,
                })
              );
            }
          }}
          type="submit"
          label={"SUPPRIMER"}
          className="p-button-danger p-button-sm"
        >
          {deleteStatus.isLoading ? (
            <FontAwesomeIcon className="ml-2" icon="spinner" spin />
          ) : null}
        </Button>
      </div>
    );
  };

  return <Button
        className="p-button-text"
        icon="pi pi-trash"
        title={'Supprimer'}
        onClick={() => {
          dispatch(
            setDialog({
              content: dialogContent(),
              title: "Supprimer"
            })
          );
        }}
      />
};

export default DeleteDatalibrayItem;